import { changeLoading } from "@/app/appSlice"
import { RootState } from "@/app/store"

export default function Error() {
    let [searchParams, setSearchParams] = useSearchParams()
    const t = useTranslate()
    const nav = useNavigate()
    const dispatch = useAppDispatch()
    const redirectUrl = useAppSelector((state: RootState) => state.app.returnUrl)

    let errorMap = {
        header:"invalid_request",
        subHeader:"too_frequent",
    }
    
    dispatch(changeLoading(false))

    useEffect(() => {
        if(redirectUrl){
            const timeout =  setTimeout(()=>{
                    window.location.href = redirectUrl
                },3000)
                return () => clearTimeout(timeout)
        }
    },[])

    return <div className="mt-14 mb-10">
        <div className="text-2xl font-bold mt-5">{t(errorMap.header)}</div>
        <div className="mt-2 mb-10">{t(errorMap.subHeader)}</div>
        {/* <div className="mt-10">
            <button className="w-full m-0 white" onClick={() => window.history.back()}>{t('back')}</button>
        </div> */}
    </div>
}